export default __webpack_public_path__ + "d8e8fdf9022e7519ce11aaf9f9158f1b.jpg";